import { ButtonSizes, FlowbiteButtonInnerTheme } from 'flowbite-react';
import { DeepPartial } from 'flowbite-react/lib/esm/types';

export interface ButtonColorsProps {
    [key: string]: string | undefined;
    primary: string;
    secondary?: string;
    outline?: string;
    destruct?: string;
    ghost?: string;
}

export type ButtonColorsEnum = keyof ButtonColorsProps;

export interface ButtonSizesProps extends ButtonSizes {
    [key: string]: string;
    md: string;
}

export type ButtonSizesEnum = keyof ButtonSizesProps;

export interface ButtonThemeProps {
    base: string;
    color: ButtonColorsProps;
    size: ButtonSizesProps;
    inner?: DeepPartial<FlowbiteButtonInnerTheme>;
}

export const buttonTheme: ButtonThemeProps = {
    // All button variant are designed not to have focus ring. Focus ring is added here to ensure expected style when other components host buttons
    base: 'justify-center items-center inline-flex disabled:opacity-50 truncate !focus:ring-0 !ring-0 p-0',
    color: {
        primary:
            'bg-system-secondary text-system-on-secondary hover:primary-hover-state active:primary-active-state primary-select-state',
        secondary:
            'bg-system-primary text-system-on-primary hover:secondary-hover-state active:secondary-active-state dark:hover:primary-hover-state dark:active:primary-active-state primary-select-state',
        outline:
            'bg-system-surface border-2 border-solid border-system-outline text-system-on-surface hover:primary-hover-state active:primary-active-state primary-select-state',
        destruct:
            'bg-system-error text-system-on-error hover:secondary-hover-state active:secondary-active-state primary-select-state',
        ghost: 'bg-system-surface text-system-on-surface hover:primary-hover-state active:primary-active-state primary-select-state',
    },
    size: {
        xs: 'px-3 py-2 items-center gap-2',
        sm: 'px-3 py-2 items-center gap-2',
        md: 'px-5 py-2.5 items-center gap-2',
        lg: 'px-5 py-3 items-center gap-2',
        xl: 'px-6 py-3.5 items-center gap-2',
    },
};

export const buttonIconTheme: ButtonThemeProps = {
    ...buttonTheme,
    base: 'justify-center items-center inline-flex relative',
    size: {
        xs: 'p-1',
        sm: 'p-2',
        md: 'p-2.5',
        lg: 'p-3',
        xl: 'p-3.5',
    },
};

export const selectButtonTheme: ButtonThemeProps = {
    base: 'flex items-center justify-between w-full max-w-[384px] disabled:opacity-50 truncate',
    inner: {
        base: 'flex w-full',
    },
    color: {
        primary:
            'rounded-lg border border-system-outline-variant border-solid bg-system-surface-container hover:primary-hover-state active:primary-active-state',
        secondary:
            'bg-system-primary text-system-on-primary hover:secondary-hover-state active:secondary-active-state dark:hover:primary-hover-state dark:active:primary-active-state',
        outline:
            'border-2 border-system-outline border-solid text-system-on-secondary hover:primary-hover-state active:primary-active-state',
        destruct: 'bg-system-error text-system-on-primary hover:secondary-hover-state active:secondary-active-state',
        ghost: 'rounded-lg bg-transparent hover:primary-hover-state active:primary-active-state',
    },
    size: {
        xs: 'px-1 py-1 items-center gap-2',
        sm: 'px-2 py-2 items-center gap-2',
        md: 'px-3 py-3 items-center gap-2',
        lg: 'px-4 py-4 items-center gap-2',
        xl: 'px-5 py-5 items-center gap-2',
    },
};
